import { config } from "../app/base/constant";
import { API_HOST } from "../config";
export const API_VERBS = {
  GET: `GET`,
  POST: `POST`,
  PUT: `PUT`,
  UPDATE: `UPDATE`,
  DELETE: `DELETE`,
  PATCH: `PATCH`,
};
export const API_ROUTE_CONTROLLER = {
  create_jwt: `${API_HOST.apiNodeURLSSO}/token/create_jwt`,
  refresh_jwt: `${API_HOST.apiNodeURLSSO}/token/refresh_jwt`,
  contacts_get: `${API_HOST.apiNodeURL}/contact/get_contact`,
  Get_admin_list: `${API_HOST.apiReactURL}/get_admin_list`,
  default_migration: `${API_HOST.apiReactURL}/default_migration`,
  update_detials: `${API_HOST.apiReactURL}/update_detials`,
  onboard_purchase: `${API_HOST.apiReactURL}/onboard_purchase`,
  purchase: `${API_HOST.apiReactURL}/purchase`,
  createIvr: `${API_HOST.apiReactURL}/createnew`,
  apiGetAddressURL: "https://api.getaddress.io/v2/uk/",
  Urmyaccweblogin: `${API_HOST.apiNodeURL}/login/Urmyaccweblogin`,
  web_token_login: `${API_HOST.apiNodeURL}/login/web_token_login`,
  Urmyaccountusermgtgetrole: `${API_HOST.apiNodeURL}/users/Urmyaccountusermgtgetrole`,
  Urgetmyaccuserlocation: `${API_HOST.apiNodeURL}/numbers_devices/Urgetmyaccuserlocation`,
  Urmaphonenumbergetcity: `${API_HOST.apiNodeURL}/numbers_devices/Urmaphonenumbergetcity`,
  Getlandlinenumberlist: `${API_HOST.apiNodeURL}/numbers_devices/Getlandlinenumberlist`,
  Urmyaccountgetavaialblemsisdn: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccountgetavaialblemsisdn`,
  getBillServicePlan: `${API_HOST.apiNodeURL}/billing/getBillServicePlan`,
  Urmyaccountgetcccardinfo: `${API_HOST.apiNodeURL}/billing/Urmyaccountgetcccardinfo`,
  Urgetaddonfeaturelist: `${API_HOST.apiNodeURL}/billing/Urgetaddonfeaturelist`,
  Urbillgetcustomerinvoicesummary: `${API_HOST.apiNodeURL}/billing/Urbillgetcustomerinvoicesummary`,
  addon_user_creation: `${API_HOST.apiNodeURL}/worktual/addon_user_creation`,
  // Urbillgetcustomerinvoicesummary: `https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/billing/Urbillgetcustomerinvoicesummary`,
  Urmyaccountviewinvoicebreakup: `${API_HOST.apiNodeURL}/billing/Urmyaccountviewinvoicebreakup`,
  Urmyaccwebgetcompanydtl: `${API_HOST.apiNodeURL}/company/Urmyaccwebgetcompanydtl`,
  getTirePlanPurposeInfo: `${API_HOST.apiServiceUrlUtms}/user/getTirePlanPurposeInfo`,
  worktualgetfeaturedetailsinfo: `${API_HOST.apiServiceUrlUtms}/product/worktualgetfeaturedetailsinfo`,
  hubspot_contact_search: `${API_HOST.apiNodeURL}/users/hubspot_contact_search`,
  Urapploginforgotpwd: `${API_HOST.apiNodeURL}/login/Urapploginforgotpwd`,
  hubspot_api: `${API_HOST.apiNodeURL}/users/hubspot_api`,
  getproductbycompany: `${API_HOST.apiNodeURL}/worktual/getproductbycompany`,
  getfeaturelistbycompanyproduct: `${API_HOST.apiNodeURL}/worktual/getfeaturelistbycompanyproduct`,
  Urmaphoneaddnumbergetnumberdtl: `${API_HOST.apiNodeURL}/numbers_devices/Urmaphoneaddnumbergetnumberdtl`,
  UrgetBillServicePlan: `${API_HOST.apiNodeURL}/billing/getBillServicePlan`,
  get_organisation_role: `${API_HOST.apiNodeURL}/worktual/get_organisation_role`,
  getroleinfo: `${API_HOST.apiNodeURL}/worktual/getroleinfo`,
  getUserId: `${API_HOST.apiCcaasURL}/getUserId`,


  //audracare

  carehome_UrgetBillServicePlan: `${API_HOST.apiCcaasHomeCareURL}/getBillServicePlan`,
  CancelRequest : `${API_HOST.apiCcaasHomeCareURL}/cancelContractRequest`,
  InsertCompany : `${API_HOST.apiCcaasHomeCareURL}/insertCompanyByReseller`,
  companyorderInfo : `https://mysqlapi.worktual.co.uk/urpartnerportal-mysql/v1/reseller/companyorderinfo`,
  dopaymentprocess : `https://mysqlapi.worktual.co.uk/urpartnerportal-mysql/v1/sme/companydopaymentprocess`,
  get_onboarding_link : `${API_HOST.apiCcaasHomeCareURL}/get_onboarding_link`,
  insert_onboarding_link : `${API_HOST.apiCcaasHomeCareURL}/insert_onboarding_link`,

  //hubspot

  setUpFee_email: `${API_HOST.API_SERVICE_URL1}/setup_email`,
  chatbot_free: `${API_HOST.API_SERVICE_URL1}/chatbot_free`,
  cancel_subscription: `${API_HOST.API_SERVICE_URL1}/cancel_subscription`,
  cancelSubscription: `${API_HOST.API_SERVICE_URL1}/cancelSubscription`,
  admin_onboard_template: `${API_HOST.API_SERVICE_URL1}/admin_onboard_template`,
  plan_activate_confirm: `${API_HOST.API_SERVICE_URL1}/plan_activate_confirm`,
  plan_activate_confirm_: `${API_HOST.API_SERVICE_URL1}/plan_activate_confirm_`,
  free_trial: `${API_HOST.API_SERVICE_URL1}/free_trial`,
  plan_activate_confirm_ccass: `${API_HOST.API_SERVICE_URL1}/plan_activate_confirm_ccass`,
  plan_activate_confirm_chatbot: `${API_HOST.API_SERVICE_URL1}/plan_activate_confirm_chatbot`,
  user_activation: `${API_HOST.API_SERVICE_URL1}/user_activation`,
  user_activation_ccass: `${API_HOST.API_SERVICE_URL1}/user_activation_ccass`,
  user_activation_chatbot: `${API_HOST.API_SERVICE_URL1}/user_activation_chatbot`,
  chatbot_free_template: `${API_HOST.API_SERVICE_URL1}/chatbot_free_template`,
  admin_activate: `${API_HOST.API_SERVICE_URL1}/admin_activate`,
  admin_deactivated: `${API_HOST.API_SERVICE_URL1}/admin_deactivated`,
  admin_cancel_user: `${API_HOST.API_SERVICE_URL1}/admin_cancel_user`,
  update_user_license: `${API_HOST.API_SERVICE_URL1}/update_user_license`,
  update_user_Details: `${API_HOST.API_SERVICE_URL1}/update_user_Details`,
  contract_cancel_monthly: `${API_HOST.API_SERVICE_URL1}/contract_cancel_monthly`,
  contract_cancel_final: `${API_HOST.API_SERVICE_URL1}/contract_cancel_final`,
  revoke_cancel: `${API_HOST.API_SERVICE_URL1}/revoke_cancel`,
  top_up_enable: `${API_HOST.API_SERVICE_URL1}/top_up_enable`,
  top_up_disable: `${API_HOST.API_SERVICE_URL1}/top_up_disable`,
  addon_cancel: `${API_HOST.API_SERVICE_URL1}/addon_cancel`,
  addon_cancel_undo: `${API_HOST.API_SERVICE_URL1}/addon_cancel_undo`,
  number_payment_success: `${API_HOST.API_SERVICE_URL1}/number_payment_success`,
  number_payment_fail: `${API_HOST.API_SERVICE_URL1}/number_payment_fail`,
  device_payment_success: `${API_HOST.API_SERVICE_URL1}/device_payment_success`,
  device_payment_fail: `${API_HOST.API_SERVICE_URL1}/device_payment_fail`,



  Urmyaccwebgetcompanyworkinghours: `${API_HOST.apiNodeURL}/company/Urmyaccwebgetcompanyworkinghours`,
  Urmyaccwebinsertcompanyworkinghours: `${API_HOST.apiNodeURL}/company/Urmyaccwebinsertcompanyworkinghours`,
  Urecomonboardgetadmindetailsinfo: `${API_HOST.apiNodeURL}/onboard/Urecomonboardgetadmindetailsinfo`,
  Urecomvalidateuserextensionstatus: `${API_HOST.apiNodeURL}/onboard/Urecomvalidateuserextensionstatus`,
  Urmyaccountgetmainnumber: `${API_HOST.apiNodeURL}/onboard/Urmyaccountgetmainnumber`,
  Urmyaccountgetpersonalinfo: `${API_HOST.apiNodeURL}/onboard/Urmyaccountgetpersonalinfo`,
  Urmyaccwebgetcompanydtlonboard: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebgetcompanydtl`,
  Urecominsertuserextensiondtl: `${API_HOST.apiNodeURL}/onboard/Urecominsertuserextensiondtl`,
  Urmyaccwebinsertcompanyworkinghoursonboard: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebinsertcompanyworkinghours`,
  Urmyaccwebinsertaudiofilecompany: `${API_HOST.apiNodeURL}/company/Urmyaccwebinsertaudiofile`,
  Urmaivroperatorextensionupdate: `${API_HOST.apiNodeURL}/onboard/Urmaivroperatorextensionupdate`,
  Urmadialbydirupdatedtl: `${API_HOST.apiNodeURL}/onboard/Urmadialbydirupdatedtl`,
  Urmyaccwebupdatecallrecording: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebupdatecallrecording`,
  Urmyaccwebivrinsertextentionaudiofile: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebivrinsertextentionaudiofile`,
  Urextncallrecordinsertsetting: `${API_HOST.apiNodeURL}/onboard/Urextncallrecordinsertsetting`,
  Urmyaccwebvoicemsgninsertextentionaudiofile: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebvoicemsgninsertextentionaudiofile`,
  Urextnvoicemailinsertsetting: `${API_HOST.apiNodeURL}/onboard/Urextnvoicemailinsertsetting`,
  Urmyaccwebinsertcallhandlingforwarding: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebinsertcallhandlingforwarding`,
  Uraddemailalertsnotifications: `${API_HOST.apiNodeURL}/onboard/Uraddemailalertsnotifications`,
  Urmyaccountinsertemailnotif: `${API_HOST.apiNodeURL}/onboard/Urmyaccountinsertemailnotif`,
  Urmyaccwebupdateextensionloginpassword: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebupdateextensionloginpassword`,
  Urmyaccwebupdateuserextensiondtl: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebupdateuserextensiondtl`,
  Urmyaccwebuserextesiondelete: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebuserextesiondelete`,
  Urmyaccemergcontactsave: `${API_HOST.apiNodeURL}/onboard/Urmyaccemergcontactsave`,
  Uronboardinsertuserdetails: `${API_HOST.apiNodeURL}/onboard/Uronboardinsertuserdetails`,
  Urwebmultiivrfeaturegetivrcount: `${API_HOST.apiNodeURL}/onboard/Urwebmultiivrfeaturegetivrcount`,
  Urmabulkupdatehubspotcontact: `${API_HOST.apiNodeURL}/onboard/Urmabulkupdatehubspotcontact`,
  Urmyaccountupdateonboardinglink: `${API_HOST.apiNodeURL}/onboard/Urmyaccountupdateonboardinglink`,
  Urmyaccwebuserorderextension: `${API_HOST.apiNodeURL}/company/Urmyaccwebuserorderextension`,
  updateDominIdForLocation: `${API_HOST.apiNodeURL}/call/update_domainid_redis`,
  upadateurmobile: `${API_HOST.apiNodeURL}/users/upadateurmobile`,
  Urmyaccwebinsertcompanyworkinghours: `${API_HOST.apiNodeURL}/onboard/Urmyaccwebinsertcompanyworkinghours`,
  Urmyaccwebupdatecompanyregionalsetting: `${API_HOST.apiNodeURL}/company/Urmyaccwebupdatecompanyregionalsetting`,
  Urmyaccwebupdatecompanydtl: `${API_HOST.apiNodeURL}/company/Urmyaccwebupdatecompanydtl`,
  Urmyaccwebgetuserextensioninfo: `${API_HOST.apiNodeURL}/users/Urmyaccwebgetuserextensioninfo`,
  Uronboardgetuserdetails: `${API_HOST.apiNodeURL}/onboard/Uronboardgetuserdetails`,
  worktualOnboardDefalutCreationDetails: `${API_HOST.apiNodeURL}/onboard/worktualOnboardDefalutCreationDetails`,

  // ccaas
  ccaasup_InsertPlanRecharge: `${API_HOST.apiNodeURL}/worktual/up_InsertPlanRecharge`,
  ccaasup_InsertPlanRecharge_v2: `${API_HOST.apiNodeURL}/worktual/up_InsertPlanRecharge_v2`,
  ccaasInsertOnboardUser: `${API_HOST.apiNodeURL}/worktual/insert_onboard_user`,
  ccaasInsertDomain: `${API_HOST.apiNodeURL}/worktual/InsertUpdateCompanyDomain`,
  ccaasSetDefaultCompany: `${API_HOST.apiNodeURL}/worktual/set_default_company`,
  ccaasInsertDefaultChatImages: `${API_HOST.apiCcaasURL}/insert_default_chat_images`,
  ccaasInsertOnboardDidNumber: `${API_HOST.apiCcaasURL}/onboard_did_number`,
  ccaasGetSkill: `${API_HOST.apiCcaasURL}/get_skill_list`,
  create_email_config: `${API_HOST.apiCcaasEmailURL}/onbord_create_email`,
  ccaasUpdateOnboardUser: `${API_HOST.apiCcaasURL}/update_Onboard_user`,
  ccaasUserDetailsMapping: `${API_HOST.apiNodeURL}/worktual/ccass_user_details_mapping`,
  ccaasMailBoxCreate: `${API_HOST.apiNodeURL}/token/ccass_domain_mailbox`,
  ccaasDomainCreateInfo: `${API_HOST.apiNodeURL}/token/domain_create_info`,
  insert_default_kevin_details: `${API_HOST.apiNodeURL}/worktual/insert_default_kevin_details`,  updateEmailBotStatus: `${API_HOST.apiCcaasEmailURL}/onbord_update_email_bot_status`,
  updateEmailBotStatus: `${API_HOST.apiCcaasEmailURL}/onbord_update_email_bot_status`,
  insert_update_facebook_configuration: `${API_HOST.apiSocialmediaServiceURL}/insert_update_facebook_configuration`,
  insert_update_instagram_configuration: `${API_HOST.apiSocialmediaServiceURL}/insert_update_instagram_configuration`,
  carehomeonboardinsert: `${API_HOST.apiCcaasHomeCareURL}/create_onboard_user_company`,


  //holiday hours
  Urmyaccountholidayannouncementcreate: `${API_HOST.apiNodeURL}/company/Urmyaccountholidayannouncementcreate`,
  Urmyaccountholidayannouncementgetdetails: `${API_HOST.apiNodeURL}/company/Urmyaccountholidayannouncementgetdetails`,
  Urmyaccwebuserorderextension: `${API_HOST.apiNodeURL}/company/Urmyaccwebuserorderextension`,


  // NFS
  save: `${API_HOST.nfsURL}/save`,
  // text_to_speech: `${config().SPEECH_URL}/texttospeech/text_to_speech`,
  text_to_speech: `https://readspeaker.worktual.co.uk/rest/vtspeech?voice=Alice&lang=en_uk&&pitch=110&speed=96&srate=16000&aformat=wav&text=`,
  upload: `${API_HOST.nfsURL}/upload`,
  Urtestcreatejwt: `${API_HOST.apiNodeURL}/login/Urtestcreatejwt`,

  //didnumPur
  getCountryList: `${API_HOST.didNumPurchaseURL}/did/v1/getCountries`,
  getGroupType: `${API_HOST.didNumPurchaseURL}/did/v1/getGroupType`,
  getCityList: `${API_HOST.didNumPurchaseURL}/did/v1/getCities`,
  getDidList: `${API_HOST.didNumPurchaseURL}/did/v1/getAvailableDids`,
  getDocumentReq: `${API_HOST.didNumPurchaseURL}/did/v1/getRequirements`,
  getskuId: `${API_HOST.didNumPurchaseURL}/did/v1/getSkuId`,
  getCreateId: `${API_HOST.didNumPurchaseURL}/did/v1/createIdentity`,
  getOrderPurchase: `${API_HOST.didNumPurchaseURL}/did/v1/order`,
  verifyApi: `${API_HOST.didNumPurchaseURL}/did/v1/verify`,
  proofTypesApi: `${API_HOST.didNumPurchaseURL}/did/v1/proofTypes`,
  encryptedFile: `${API_HOST.didNumPurchaseURL}/did/v1/encryptFiles`,
  get_country_by_iso3: `${API_HOST.apiNodeURL}/numbers_devices/get_country_by_iso3`,
  getoperator: `${API_HOST.apiNodeURL}/numbers_devices/getoperator`,
  didnumber_upload_integration: `${API_HOST.apiNodeURL}/numbers_devices/didnumber_upload_integration`,


  //tata didPur
  getTataCountryList: `${API_HOST.didNumPurchaseURL}/did/v1/tata/getCountries`,
  getTataCityList: `${API_HOST.didNumPurchaseURL}/did/v1/tata/getCities`,
  getTataAvailDidList: `${API_HOST.didNumPurchaseURL}/did/v1/tata/getAvailableDids?countryCode=`,

  //devices

  Urmaphonenumbergetcountry: `${API_HOST.apiNodeURL}/numbers_devices/Urmaphonenumbergetcountry`,

  Urdevicegetstockorder: `${API_HOST.apiNodeURL}/numbers_devices/Urdevicegetstockorder`,
  Urdevicegetstockorderdtl: `${API_HOST.apiNodeURL}/numbers_devices/Urdevicegetstockorderdtl`,
  Urmyaccemergcontactget: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccemergcontactget`,
  Urmyaccaddphonegetdirectnumber: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccaddphonegetdirectnumber`,
  Urgetproductlistforweborder: `${API_HOST.apiNodeURL}/numbers_devices/Urgetproductlistforweborder`,
  Urmyaccountgetdevicebrandtype: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccountgetdevicebrandtype`,
  Urshippingcarrierget: `${API_HOST.apiNodeURL}/numbers_devices/Urshippingcarrierget`,
  Urmyaccountgetemailnotif: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccountgetemailnotif`,
  Urgetemailalertsnotifications: `${API_HOST.apiNodeURL}/numbers_devices/Urgetemailalertsnotifications`,
  Urdeviceinsertstockorder: `${API_HOST.apiNodeURL}/numbers_devices/Urdeviceinsertstockorder`,
  Urmainsertphoneaddnumber: `${API_HOST.apiNodeURL}/numbers_devices/Urmainsertphoneaddnumber`,
  Urmyaccgetportinrequest: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccgetportinrequest`,
  Urmaphoneupdatemacaddress: `${API_HOST.apiNodeURL}/company/Urmaphoneupdatemacaddress`,
  Urmaupdateprovisionfiledtl: `${API_HOST.apiNodeURL}/company/Urmaupdateprovisionfiledtl`,
  Urdeviceorderreturninsert: `${API_HOST.apiNodeURL}/numbers_devices/Urdeviceorderreturninsert`,
  Urdeviceorderreplacementinsert: `${API_HOST.apiNodeURL}/numbers_devices/Urdeviceorderreplacementinsert`,
  Urmyaccountgetinvoiceidbyorderreference: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccountgetinvoiceidbyorderreference`,
  Urmyaccountcreateinvoicedetail: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccountcreateinvoicedetail`,

  // hunt group
  Urmyaccounthuntgroupgetcustomhour: `${API_HOST.apiNodeURL}/call/Urmyaccounthuntgroupgetcustomhour`,
  Urmyaccwebuserorderextension: `${API_HOST.apiNodeURL}/company/Urmyaccwebuserorderextension`,
  Urmyacccountgethuntgroupdtl: `${API_HOST.apiNodeURL}/call/Urmyacccountgethuntgroupdtl`,
  Urmyaccountcheckfeatureinfo: `${API_HOST.apiNodeURL}/call/Urmyaccountcheckfeatureinfo`,
  Urmyaccountgetcompanyaddress: `${API_HOST.apiNodeURL}/worktual/get_company_address`,
  Urmyaccountinsertcompanyaddress: `${API_HOST.apiNodeURL}/worktual/insert_company_address`,
  Urmyaccwebivrgetmusictype: `${API_HOST.apiNodeURL}/call/Urmyaccwebivrgetmusictype`,
  ///Trancscription
  updateTranscriptSettings: `${API_HOST.apiNodeURL}/transcription/updateTranscriptSettings`,
  getTranscriptSettings: `${API_HOST.apiNodeURL}/transcription/getTranscriptSettings`,

  // Regional Settings
  Urmyaccwebgetcompanyregionalsettingdtl: `${API_HOST.apiNodeURL}/userpanel/Urmyaccwebgetcompanyregionalsettingdtl`,
  Urmyaccwebupdatecompanyregionalsetting: `${API_HOST.apiNodeURL}/company/Urmyaccwebupdatecompanyregionalsetting`,
  //user Panel
  ur_myacc_domain_get_cdr_details_report: `${API_HOST.apiNodeURL}/worktual/ur_myacc_domain_get_cdr_details_report`,

  //parl location
  Urparklocationgetgroupmembers: `${API_HOST.apiNodeURL}/call/Urparklocationgetgroupmembers`,
  Urparklocationinsertgroup: `${API_HOST.apiNodeURL}/call/Urparklocationinsertgroup`,
  Urgetcompanyextensiondtl: `${API_HOST.apiNodeURL}/call/Urgetcompanyextensiondtl`,
  Urparklocationdelete: `${API_HOST.apiNodeURL}/call/Urparklocationdelete`,
  Urparklocationupdategroupmembers: `${API_HOST.apiNodeURL}/call/Urparklocationupdategroupmembers`,

  //smart assist
  ur_myaccount_manage_smart_assistant_info: `${API_HOST.apiNodeURL}/call/ur_myaccount_manage_smart_assistant_info`,
  ur_myaccount_get_smart_assistant_info: `${API_HOST.apiNodeURL}/call/ur_myaccount_get_smart_assistant_info`,


  Urmyaccwebgetuserpersonaldtl: `${API_HOST.apiNodeURL}/userpanel/Urmyaccwebgetuserpersonaldtl`,
  Urmyaccgetcountrylistinfo: `${API_HOST.apiNodeURL}/userpanel/Urmyaccgetcountrylistinfo`,
  Urmyaccwebsaveuserpersonaldtl: `${API_HOST.apiNodeURL}/userpanel/Urmyaccwebsaveuserpersonaldtl`,
  Urmyaccwebgetgetcalleriddtl: `${API_HOST.apiNodeURL}/numbers_devices/Urmyaccwebgetgetcalleriddtl`,
  Urmyaccgetconferencemasterinfo: `${API_HOST.apiNodeURL}/userpanel/Urmyaccgetconferencemasterinfo`,
  Urmagetavailableconferencenumberdtl: `${API_HOST.apiNodeURL}/userpanel/Urmagetavailableconferencenumberdtl`,
  Urusergetphoneinfo: `${API_HOST.apiNodeURL}/userpanel/Urusergetphoneinfo`,
  Urextnphonenameupdate: `${API_HOST.apiNodeURL}/userpanel/Urextnphonenameupdate`,
  Urmyaccwebgetupdatecalleridnumber: `${API_HOST.apiNodeURL}/userpanel/Urmyaccwebgetupdatecalleridnumber`,
  Urmyaccwebgetcompanyregionalsettingdtl: `${API_HOST.apiNodeURL}/userpanel/Urmyaccwebgetcompanyregionalsettingdtl`,
  Urdisplaypicture: `${API_HOST.apiNodeURL}/userpanel/Urdisplaypicture`,
  Urextnvoicemailgetsetting: `${API_HOST.apiNodeURL}/users/Urextnvoicemailgetsetting`,

  // common file uploads
  file_upload: `${API_HOST.apiNodeURL}/worktual/file_upload`,
  //update user
  update_myaccount_user: `${API_HOST.API_SERVICE_SSO_V2_URL}/administration/update_myaccount_user`,

  //
  get_policy_info: `${API_HOST.apiNodeURL}/policy/get_policy_info`,

  //mail api
  forgot_password_link_send: `https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/forgot_password_req`,
  getUserDetailsByEmail: `${API_HOST.apiNodeURL}/worktual/get_user_details_by_email`,

  //crm
  insertOnboardCrmUser: `${API_HOST.MARKETING_SERVICE}/common/insert_onboard_user`,
  createEmailconfigDetails: `${API_HOST.MARKETING_SERVICE}/common/CRM_create_email_config_details `,
  marketing_updateUserDetails: `${API_HOST.MARKETING_SERVICE}/email/marketing_updateUserDetails `,
  marketing_deleteUserDetails: `${API_HOST.MARKETING_SERVICE}/email/marketing_deleteUserDetails `,
  user_default_workinghours :`${API_HOST.MARKETING_SERVICE}/booking/user_default_workinghours`,
  ab_forgot_password_reset :`${API_HOST.MARKETING_SERVICE}/booking/ab_forgot_password_reset`,
  


  CRM_create_sms_config_details:`${API_HOST.BOOKING_SERVICE}/CRM_create_sms_config_details`,
  ab_insert_update_notification_email_config_dtl:`${API_HOST.BOOKING_SERVICE}/ab_insert_update_notification_email_config_dtl`,



  //plan upgrade
  Urmainsertplanchangerequest: `${API_HOST.apiNodeURL}/users/Urmainsertplanchangerequest`,
  new_prod_purchaseApi: `${API_HOST.apiNodeURL}/call/secondary_plan_purchase_request`,
  ur_ma_get_secondary_plan: `${API_HOST.apiNodeURL}/worktual/ur_ma_get_secondary_plan`,
  wtms_bill_get_service_plan_exclude_sec_plan: `${API_HOST.apiNodeURL}/worktual/wtms_bill_get_service_plan_exclude_sec_plan`,



  get_admin_info_for_crm: `${API_HOST.apiNodeURL}/worktual/get_admin_info_for_crm`,
  ur_get_all_active_plan_by_company_id: `${API_HOST.apiNodeURL}/worktual/ur_get_all_active_plan_by_company_id`,
  insert_secondary_plan_change_request: `${API_HOST.apiNodeURL}/worktual/insert_secondary_plan_change_request`,
  get_sales_team_extn_info: " https://mysqlapi.worktual.co.uk/urutms-mysql/v1/user//ur_get_sales_team_extn_info",


  //teams
  refresh_token: `${API_HOST.CCAAS_CONNECTOR_URL}/directrouting/teams/refresh_token`,
  
  emailMarketing_appointment_insert:`${API_HOST.apiNodeURL}/worktual/emailMarketing_appointment_insert`,
  emailMarketing_appointment_insert_new:`${API_HOST.apiNodeURL}/worktual/emailMarketing_appointment_insert_new`,
  facebook_insta_insert:`${API_HOST.apiNodeURL}/worktual/facebook_insta_insert`,

  get_addon_list: `${API_HOST.apiNodeURL}/worktual/get_addon_list`,

  forgot_password_backend: `${API_HOST.apiNodeURL}/login/forgot_password_backend`,

    bulk_addon_purchase: `${API_HOST.apiNodeURL}/worktual/bulk_addon_purchase`,
    insertCcaasAddOnList: `${config().callServices}/onboard_company_purchase_addon`,
    doAddonPurchase: `${config().API_SERVICE_URL}/addon/doAddonPurchase`,

    stripe_payment_v1:`${config().API_SERVICE_URL}/payment/payment_v1`,
    qastripe_payment_v1:`${config().API_SERVICE_URL}/payment/qapayment_v1`,
      worktualGetProdWiseAddonList: `${config().API_SERVICE_URL_UTMS}/product/worktualGetProdWiseAddonList`,
     insert_update_product_access: `${API_HOST.apiNodeURL}/login/insert_update_product_access`,


};


